export const BREAKDOWN_GET_BY_ID_REQUEST = 'BREAKDOWN_GET_BY_ID_REQUEST';
export const BREAKDOWN_GET_BY_ID_SUCCESS = 'BREAKDOWN_GET_BY_ID_SUCCESS';
export const BREAKDOWN_GET_BY_ID_FAILED = 'BREAKDOWN_GET_BY_ID_FAILED';



// WEBPACK FOOTER //
// ./src/Store/ActionTypes/BreakdownActionTypes.js